import { ConsentFetchModel } from "../../models/settings/consent.fetch.model";

export const CONSENT_FETCHED = "CONSENT_FETCHED";
export const APP_CONSENTS_FETCHED = "APP_CONSENTS_FETCHED";
export const APP_CONSENTS_CHECK_ONE = "APP_CONSENTS_CHECK_ONE";
export const APP_CONSENTS_TOGGLE_ALL = "APP_CONSENTS_TOGGLE_ALL";
export const APP_CONSENTS_VALIDATE_ALL = "APP_CONSENTS_VALIDATE_ALL";

export interface ConsentFetchedAction {
    type : typeof CONSENT_FETCHED;
    payload: ConsentFetchModel
}
export interface AppConsentFetchedAction {
    type : typeof APP_CONSENTS_FETCHED;
    payload: ConsentFetchModel
}
export interface AppConsentCheckOneAction {
    type : typeof APP_CONSENTS_CHECK_ONE;
    payload: number;
}
export interface AppConsentToogleAllAction {
    type : typeof APP_CONSENTS_TOGGLE_ALL;
    payload: boolean
}
export interface AppConsentValidateAllAction {
    type : typeof APP_CONSENTS_VALIDATE_ALL;
}

export type ConsentFetchedActions =
  | ConsentFetchedAction
  | AppConsentFetchedAction
  | AppConsentCheckOneAction
  | AppConsentToogleAllAction
  | AppConsentValidateAllAction